import { LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export const UnknownAccount = ({ heading }: { heading: string }) => {
  return (
    <AuthTemplate
      heading={heading}
      subheading={<UnknownAccountSubheading />}
      footer={<FooterLinks />}
    >
      <Button asChild>
        <Link to="/">
          <LogIn className="w-4 h-4 mr-2" />
          Continue to FlagSync
        </Link>
      </Button>
    </AuthTemplate>
  );
};

function UnknownAccountSubheading() {
  return (
    <div className="flex flex-col space-y-2">
      <span>
        Hmm, we couldn&apos;t locate that account. Did you recently update your
        account&apos;s email address?
      </span>
      <span>
        Feel free to contact us at{' '}
        <Link className="font-semibold" to="mailto:support@flagsync.com">
          support@flagsync.com
        </Link>{' '}
        and we can take a look.
      </span>
    </div>
  );
}
